import { useState } from 'react'
import { Target, ChevronDown, ChevronUp, Plus } from 'lucide-react'
import './LearningGoals.css'
import { Button } from '../../../common/components/button/Button'
import { LearningGoal } from '../EngineHelper'

interface LearningGoalsProps {
  goals: LearningGoal[]
  onDeleteGoal?: (goal: LearningGoal) => void
  onAddGoal?: (goal: LearningGoal) => void
  editable?: boolean
}

export const LearningGoals = ({ goals, onDeleteGoal, onAddGoal, editable }: LearningGoalsProps) => {
  const [isExpanded, setIsExpanded] = useState(false)
  const [newGoalTitle, setNewGoalTitle] = useState('')
  const [newGoalDescription, setNewGoalDescription] = useState('')

  const handleAddGoal = () => {
    if (newGoalTitle.trim() && newGoalDescription.trim()) {
      onAddGoal?.({ title: newGoalTitle, text: newGoalDescription })
      setNewGoalTitle('')
      setNewGoalDescription('')
    }
  }

  return (
    <div className='learning-goals-card'>
      <div className='learning-goals-container'>
        <div className='learning-goals-header'>
          <div className='learning-goals-title-wrapper'>
            <Target className='learning-goals-icon' />
            <h2 className='learning-goals-title'>Learning Goals</h2>
          </div>
          <Button
            variant='borderless-tiny'
            onClick={() => setIsExpanded(!isExpanded)}
            className='learning-goals-toggle-btn'
          >
            {isExpanded ? (
              <>
                <ChevronUp className='learning-goals-toggle-icon' />
                Collapse
              </>
            ) : (
              <>
                <ChevronDown className='learning-goals-toggle-icon' />
                Expand
              </>
            )}
          </Button>
        </div>

        {isExpanded ? (
          <div className='learning-goals-expanded-list'>
            {goals.map((goal, index) => (
              <div key={index} className='learning-goal-item'>
                <div className='learning-goal-content-wrapper'>
                  <div className='learning-goal-text-content'>
                    <h3 className='learning-goal-item-title'>{goal.title}</h3>
                    <p className='learning-goal-item-description'>{goal.text}</p>
                  </div>
                  {editable && (
                    <Button
                      variant='borderless-tiny'
                      className='learning-goal-delete-btn'
                      onClick={() => onDeleteGoal?.(goal)}
                    >
                      {'Delete'}
                    </Button>
                  )}
                </div>
              </div>
            ))}

            {editable && (
              <div className='learning-goals-add-section'>
                <div className='learning-goals-form'>
                  <input
                    placeholder='New goal title...'
                    value={newGoalTitle}
                    onChange={(e) => setNewGoalTitle(e.target.value)}
                    className='learning-goals-input'
                  />
                  <textarea
                    placeholder='Goal description...'
                    value={newGoalDescription}
                    onChange={(e) => setNewGoalDescription(e.target.value)}
                    className='learning-goals-textarea'
                    rows={2}
                  />
                </div>
                <Button
                  onClick={handleAddGoal}
                  className='learning-goals-add-btn'
                  disabled={!newGoalTitle.trim() || !newGoalDescription.trim()}
                >
                  <Plus className='learning-goals-add-icon' />
                  Add Learning Goal
                </Button>
              </div>
            )}
          </div>
        ) : (
          <div className='learning-goals-badge-list'>
            {goals.map((goal, index) => (
              <div key={index} className='learning-goal-badge'>
                {goal.title}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
